<template>
  <div>
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>{{ $t('contact.title') }}</h1>
        <p>{{ $t('contact.subtitle') }}</p>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-section">
      <div class="container">
        <div class="contact-content">
          <div class="contact-info">
            <h3>{{ $t('contact.contactInfo') }}</h3>
            <table>
              <tbody>
                <tr>
                  <th>{{ $t('contact.name') }}</th>
                  <th>{{ $t('contact.details') }}</th>
                </tr>
                <tr>
                  <td>{{ $t('contact.qqGroup') }}</td>
                  <td>873673497</td>
                </tr>
                <tr>
                  <td>{{ $t('contact.telegram') }}</td>
                  <td>
                    <a
                      href="https://t.me/+Ld74JCAEzv1hNGE1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >https://t.me/+Ld74JCAEzv1hNGE1</a>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('contact.website') }}</td>
                  <td><a href="https://turingevo.com">turingevo.com</a></td>
                </tr>
                <tr>
                  <td>{{ $t('contact.email') }}</td>
                  <td><a href="mailto:wmx@turingevo.com">wmx@turingevo.com</a></td>
                </tr>
                <tr>
                  <td>{{ $t('contact.blog') }}</td>
                  <td><a href="https://turingevo.com/blog">https://turingevo.com/blog</a></td>
                </tr>
                <tr>
                  <td>{{ $t('contact.csdn') }}</td>
                  <td><a href="https://turingevo.blog.csdn.net/">https://turingevo.blog.csdn.net/</a></td>
                </tr>
                <tr>
                  <td>{{ $t('contact.github') }}</td>
                  <td><a href="https://github.com/turingevo">https://github.com/turingevo</a></td>
                </tr>
                <tr>
                  <td>{{ $t('contact.huggingface') }}</td>
                  <td><a href="https://huggingface.co/turingevo">https://huggingface.co/turingevo</a></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="contact-form-wrapper">
            <h3>{{ $t('contact.sendMessage') }}</h3>
            <p>{{ $t('contact.fillForm') }}</p>
            <form @submit.prevent="handleSubmit" class="contact-form">
              <div class="form-group">
                <label for="name">{{ $t('contact.yourName') }}</label>
                <input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :placeholder="$t('contact.yourName')"
                  required
                />
              </div>
              <div class="form-group">
                <label for="email">{{ $t('contact.yourEmail') }}</label>
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  :placeholder="$t('contact.yourEmail')"
                  required
                />
              </div>
              <div class="form-group">
                <label for="subject">{{ $t('contact.subject') }}</label>
                <input
                  id="subject"
                  v-model="form.subject"
                  type="text"
                  :placeholder="$t('contact.subject')"
                  required
                />
              </div>
              <div class="form-group">
                <label for="message">{{ $t('contact.message') }}</label>
                <textarea
                  id="message"
                  v-model="form.message"
                  rows="5"
                  :placeholder="$t('contact.message')"
                  required
                ></textarea>
              </div>
              <button type="submit" class="btn btn-primary">
                {{ $t('contact.send') }}
              </button>
            </form>
          </div>
        </div>

        <div class="contact-images">
          <div class="image-container">
            <figure class="image-card">
              <img src="/img/wechat.png" alt="Turing Evo WeChat" />
              <figcaption>{{ $t('contact.enterpriseWechat') }}</figcaption>
            </figure>
            <figure class="image-card">
              <img src="/img/WeChatOfficialAccount.jpg" alt="WeChat Official Account" />
              <figcaption>{{ $t('contact.officialAccount') }}</figcaption>
            </figure>
            <figure class="image-card">
              <img src="/img/TuringEvo.jpg" alt="Turing Evo Video" />
              <figcaption>{{ $t('contact.videoChannel') }}</figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      window.location.href = `mailto:wmx@turingevo.com?subject=${encodeURIComponent(this.form.subject)}&body=${encodeURIComponent(
        `来自: ${this.form.name} (${this.form.email})\n\n${this.form.message}`
      )}`
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  color: white;
  padding: 100px 20px;
  text-align: center;
}

.hero h1 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 20px;
}

.hero p {
  font-size: 1.25rem;
  margin-bottom: 30px;
}

/* Contact Section */
.contact-section {
  padding: 80px 20px;
  background-color: #f8f9fa;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-top: 40px;
}

.contact-info table {
  width: 100%;
  border-collapse: collapse;
}

.contact-info th, .contact-info td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.contact-info th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.contact-info a {
  color: #667eea;
  text-decoration: none;
  word-break: break-all;
}

.contact-info a:hover {
  text-decoration: underline;
}

/* Contact Form */
.contact-form-wrapper {
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
}

.contact-form-wrapper h3 {
  font-size: 1.3rem;
  margin-bottom: 8px;
  color: #222;
}

.contact-form-wrapper p {
  color: #666;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
}

/* Contact Images */
.contact-images {
  margin-top: 60px;
}

.image-container {
  display: flex;
  justify-content: center;
  gap: 40px;
}

.image-card {
  text-align: center;
  margin: 0;
}

.image-card img {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.image-card figcaption {
  margin-top: 12px;
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }

  .contact-content {
    grid-template-columns: 1fr;
  }

  .image-container {
    flex-direction: column;
    align-items: center;
  }
}
</style>
